import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { Pencil, Trash2 } from "lucide-react";
import Loader from "../layout/Loader";
import AdminProfile from "../user/AdminProfile";
import { useDeleteUserMutation, useGetAdminUsersQuery } from "../../redux/api/userApi";
import { Helmet } from "react-helmet-async";

const ListUsers = () => {
  const { data, isLoading, error } = useGetAdminUsersQuery();


  const [
    deleteUser,
    { error: deleteError, isLoading: isDeleteLoading, isSuccess },
  ] = useDeleteUserMutation();

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message);
    }

    if (deleteError) {
      toast.error(deleteError?.data?.message);
    }

    if (isSuccess) {
      toast.success("User Deleted");
    }
  }, [error, deleteError, isSuccess]);

  const deleteUserHandler = (id) => {
    deleteUser(id);
  };

  if (isLoading) return <Loader />;

  return (
    <AdminProfile>
      <Helmet>
        <title>Users</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="max-w-6xl mx-auto mt-10 ">
        <h1 className="text-2xl font-playfair text-[#1c1917] mb-6">
          {data?.users?.length} Users
        </h1>

        {/* Responsive wrapper */}
        <div className="bg-[#f5f3ea] rounded-lg shadow border border-[#e2e1d8] overflow-x-auto">
          <table className="w-full min-w-[200px] table-auto">
            <thead className="bg-white/70">
              <tr className="text-left text-[#1c1917] font-playfair text-xs sm:text-sm uppercase tracking-wide border-b border-[#e2e1d8]">
                <th className="px-2 sm:px-2 py-3">ID</th>
                <th className="px-2 sm:px-2 py-3">Name</th>
                <th className="px-1 sm:px-2 py-3">Email</th>
                <th className="px-1 sm:px-2 py-3">Role</th>
                <th className="px-1 sm:px-2 py-3 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y w-full text-center divide-[#e2e1d8] font-sourcesans text-xs sm:text-sm">
              {data?.users?.map((user) => (
                <tr key={user?._id} className="hover:bg-white/50 transition">
                  <td className="px-2 sm:px-2 break-all">{user?._id}</td>
                  <td className="px-2 sm:px-2 break-all">{user?.name}</td>
                  <td className="px-2 sm:px-2 break-all">{user?.email}</td>
                  <td className="px-2 sm:px-2 break-all">{user?.role}</td>
                
                  <td className="px-2 sm:px-2 py-6 text-center">
                    <div className="flex  justify-end flex-wrap gap-2">
                      <Link
                        to={`/admin/users/${user?._id}`}
                        className="px-2 py-1 border border-[#8a4b32]/50 rounded-md text-xs text-[#1c1917] hover:border-[#BC3F4A] hover:text-[#BC3F4A] transition"
                        title="Edit"
                      >
                       <Pencil className="w-3.5 h-3.5" />
                      </Link>

                      <button
                        onClick={() => deleteUserHandler(user?._id)}
                        disabled={isDeleteLoading}
                        className="px-2 py-1 border border-[#BC3F4A]/60 rounded-md text-xs text-[#BC3F4A] hover:bg-[#BC3F4A] hover:text-white transition disabled:opacity-50"
                        title="Delete"
                      >
                       <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}

              {data?.orders?.length === 0 && (
                <tr>
                  <td
                    colSpan="4"
                    className="px-4 py-6 text-center text-[#1c1917] font-sourcesans"
                  >
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminProfile>
  );
};

export default ListUsers;
